/** display_order → Traditional Chinese title for TWCBT (frontend override). */
const twcbtChineseTitles: Record<number, string> = {
  1: '上帝創造世界',
  2: '亞當與夏娃違背上帝的命令',
  3: '大洪水',
  4: '上帝與挪亞立約',
  5: '上帝呼召亞伯拉罕',
  6: '以撒出生',
  7: '雅各和以掃',
  8: '約瑟和他的兄弟',
  9: '埃及王奇怪的夢',
  10: '摩西被救',
  11: '上帝降下十災',
  12: '以色列人民過紅海',
  13: '上帝以嗎哪和鵪鶉餵養以色列人民',
  14: '上帝給以色列人民的十誡',
  15: '探子偵查迦南地',
  16: '耶利哥城倒塌',
  17: '基甸打敗米甸人',
  18: '參孫的故事',
  19: '路得和波阿斯',
  20: '上帝呼召孩童撒母耳',
  21: '掃羅受膏成為以色列王',
  22: '掃羅和大衛',
  23: '大衛擊敗歌利亞',
  24: '大衛與約拿單',
  25: '所羅門奉獻聖殿',
  26: '以利亞挑戰巴力的先知們',
  27: '乃縵皮膚病得醫治',
  28: '約西亞八歲作王',
  29: '以色列人民被擄',
  30: '以色列人民重建聖殿',
  31: '以斯帖的故事 (上)',
  32: '以斯帖的故事 (中)',
  33: '以斯帖的故事 (下)',
  34: '約伯的故事',
  35: '上主是我的牧者',
  36: '讚美上主',
  37: '向小螞蟻學習功課',
  38: '和平的國度',
  39: '但以理被丟入獅子坑',
  40: '約拿的故事',
  41: '東方星象家朝拜嬰孩耶穌',
  42: '牧羊人找到嬰孩耶穌',
  43: '十二歲的耶穌在聖殿中',
  44: '耶穌受洗',
  45: '耶穌呼召漁夫成為門徒',
  46: '迦拿的婚宴',
  47: '耶穌治好癱瘓病人',
  48: '耶穌平靜風浪',
  49: '撒種的比喻',
  50: '耶穌讓葉魯的女兒死而復生',
  51: '耶穌以五餅二魚餵飽五千人',
  52: '好撒馬利亞人的善行',
  53: '迷失的羊',
  54: '浪子回頭',
  55: '耶穌祝福小孩子',
  56: '拉撒路復活',
  57: '耶穌和撒該',
  58: '耶穌進入耶路撒冷',
  59: '最後的晚餐',
  60: '耶穌被釘死在十字架上',
  61: '耶穌復活並向不信的多馬顯現',
  62: '耶穌升天',
  63: '五旬節聖靈降臨',
  64: '彼得醫好跛腳的人',
  65: '司提反被石頭打死',
  66: '掃羅悔改',
  67: '保羅旅行各地傳揚福音',
  68: '要常常喜樂',
  69: '為生病的人禱告',
  70: '新天新地',
};

export default twcbtChineseTitles;
